import React, { useState, useEffect } from "react";
import { DatePicker, Popover, Spin } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import TextArea from "antd/lib/input/TextArea";
import { AiOutlineClose } from "react-icons/ai";
import Axios from "axios";
import {
  Button1,
  ButtonMassActions,
  SelectForm,
} from "../../../../components/common/Buttons";
import { comment_type_options } from "../../../../components/common/CommentState_type";
import { BlueButton } from "../../../../components/common/ButtonWithLoading";
import SupplyComponent from "../../../../components/common/GlobalModals/Orders/editModal/SupplyComponent";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import { errorHandler } from "../../../../helpers/Utils";
import { postMassCommentsAndStatus } from "../../../../redux/Actions/commentAction";
import { postMassSupplyings } from "../../../../redux/Actions/supplyingsAction";
import { shipmentBulkAction } from "../../../../redux/Actions/bulk_shipment_action";
import { getStatusesOptions } from "../../../../redux/Actions/statusesAction";
import {
  setGlobalModal,
  createBulkReturns,
} from "../../../../redux/Actions/orderAction";

const NOTE_REMINDER_DEFAULT_TIME = "15:00";

export default function OrderBulkAction({
  checkedArray,
  checkedArrayFull,
  comments_state,
  order_rows_accepted,
  unCheck,
  modalRef,
}) {
  const dispatch = useDispatch();
  const [type, setType] = useState("");
  const bulk_shipments = useSelector((state) => state.orders.bulk_shipments);
  const permissions = useSelector(
    (state) => state.auth.user.user_role?.permissions || {}
  );
  const canCreatePo = !!permissions.also_income_module_create_po;

  const reformattedOrders = checkedArrayFull?.map((order) => ({
    status: "new",
    return_type: "logistics",
    order_id: order.id,
    order_row_returns_attributes: order.order_rows
      .filter((row) => order_rows_accepted.includes(row.id))
      .map((row) => ({
        order_row_id: row.id,
        qty: parseFloat(row.quantity),
        title: row.product_name,
        price: row.product_price,
      })),
  }));

  return (
    <Popover
      placement="right"
      title={
        <div className="d-flex align-items-center justify-content-between py-2">
          <div className="font-semi-bold text-base text-black">
            {type == "comment"
              ? "Comment and status"
              : type == "supply"
                ? "Supply"
                : ""}
          </div>
          <AiOutlineClose
            className="cursor-pointer text-black"
            onClick={() => setType("")}
          />
        </div>
      }
      content={
        type == "comment" ? (
          <CommentAndStatus
            checkedArray={checkedArray}
            comments_state={comments_state}
            setType={setType}
            unCheck={unCheck}
          />
        ) : type == "supply" ? (
          <Supply
            order_rows_accepted={order_rows_accepted}
            setType={setType}
            unCheck={unCheck}
          />
        ) : (
          ""
        )
      }
      visible={type}
      onVisibleChange={() => setType(false)}
      trigger="click"
    >
      <ButtonMassActions
        text={<>Bulk action </>}
        actions={[
          {
            label: (
              <span>
                Supply{" "}
                {
                  <span className="badge badge-light">
                    {order_rows_accepted.length}
                  </span>
                }
              </span>
            ),
            onFunction: () => setType("supply"),
          },
          {
            label: (
              <span>
                Comment and status{" "}
                {
                  <span className="badge badge-light">
                    {checkedArray.length}
                  </span>
                }
              </span>
            ),
            onFunction: () => setType("comment"),
          },
          {
            label: "Open all bulk shipments",
            onFunction: () => {
              console.log("Open");
              document
                .querySelectorAll(".mass_bulk_action_open")
                .forEach((el) => el.click());
            },
          },
          {
            label: (
              <span>
                Generate shipments
                {
                  <span className="badge badge-light">
                    {Object.values(bulk_shipments).flat().length}
                  </span>
                }
              </span>
            ),
            onFunction: () => {
              console.log("Call function");
              dispatch(shipmentBulkAction());
            },
          },
          ...(canCreatePo
            ? [
                {
                  label: (
                    <span>
                      Create PO & assign supply
                      {
                        <span className="badge badge-light">
                          {order_rows_accepted.length}
                        </span>
                      }
                    </span>
                  ),
                  onFunction: () => {
                    dispatch(
                      setGlobalModal(
                        true,
                        [...order_rows_accepted],
                        "CreatePOAssignSupplyModal"
                      )
                    );
                  },
                },
              ]
            : []),
          {
            label: (
              <span>
                Assign supply date
                {
                  <span className="badge badge-light">
                    {order_rows_accepted.length}
                  </span>
                }
              </span>
            ),
            onFunction: () => {
              dispatch(
                setGlobalModal(
                  true,
                  [...order_rows_accepted],
                  "AssignSupplyDateModal"
                )
              );
            },
          },
          {
            label: (
              <span>
                Create return
                {
                  <span className="badge badge-light">
                    {order_rows_accepted.length}
                  </span>
                }
              </span>
            ),
            onFunction: () => {
              dispatch(createBulkReturns(reformattedOrders));
            },
          },
          {
            label: <span>Preview actions history (OLD)</span>,
            onFunction: () => {
              modalRef.openModal("ModalActionHistory");
            },
          },
          {
            hr: true,
          },
          {
            label: <span>Preview actions history</span>,
            onFunction: () => unCheck("modal_bulk_action_preview"),
          },
        ]}
      />
    </Popover>
  );
}

const CommentAndStatus = ({
  checkedArray,
  comments_state,
  setType,
  unCheck,
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(undefined);
  const [errors, setErrors] = useState({});

  //
  const [newStatus, setNewStatus] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statuses, setStatuses] = useState([]);
  const [loadingAsync, setLoadingAsync] = useState(false);

  // COmment
  const [commentType, setCommentType] = useState(undefined);
  const [comment_state_id, set_comment_state_id] = useState(undefined);
  const [body, setBody] = useState("");
  const [commentDate, setCommentDate] = useState("");

  const selectedCommentState = comments_state.find(
    (state) => state.value == comment_state_id
  );
  const requiresReminderDate =
    commentType === "comment_management" &&
    selectedCommentState?.name?.toLowerCase() === "note";

  useEffect(() => {
    if (checkedArray.length == 0) return;

    Axios.post("/api/v1/orders/post_search", {
      page: 1,
      per_page: 100000,
      q: {
        id_in: checkedArray,
      },
    }).then((res) => {
      console.log("Resas: ", res);
      setData(res.data.data || []);
      const shop_stores_id = [
        ...new Set(res.data.data.map((d) => d.order_shop_id)),
      ];
      if (shop_stores_id.length > 1) {
        setErrors((prev) => ({
          ...prev,
          status: "Selected orders with a different stores",
        }));
      }
      getStatusesOptions().then((statuses) =>
        setStatuses(statuses.filter((d) => d.shop_id == shop_stores_id[0]))
      );
      setLoading(false);
    });
  }, []);

  if (checkedArray.length == 0) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: 471,
        }}
      >
        Not selected
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: 471,
        }}
      >
        <Spin />
      </div>
    );
  }

  const onSubmit = async () => {
    try {
      setLoadingAsync(true);
      let params = {
        orders_ids: checkedArray,
        status_id: newStatus ? status : false,
        comment: false,
      };
      if (commentType && comment_state_id) {
        if (requiresReminderDate && !commentDate) {
          setErrors((prev) => ({
            ...prev,
            commentDate: "Reminder date and time is required",
          }));
          setLoadingAsync(false);
          return { success: false };
        }

        params.comment = {
          comment_type: commentType,
          comment_state_id,
          body,
          date: commentDate || undefined,
        };
      }

      const { success } = await dispatch(postMassCommentsAndStatus(params));
      if (!success) throw new Error("ERR");
      setType("");
      unCheck("orders", []);
      return { success: true };
    } catch (err) {
      errorHandler(err);
      return { success: false };
    } finally {
      setLoadingAsync(false);
    }
  };

  return (
    <div
      style={{
        width: 471,
      }}
    >
      <h5 className="font-semi-bold text-sm text-black">Orders selected</h5>
      <div className="d-flex flex-wrap">
        {data.map((d) => (
          <div
            key={d.id_order}
            className="text-sm text-black mr-2 py-1 px-2 rounded bg-silver"
          >
            {d.id_order}
          </div>
        ))}
      </div>
      <div>
        {errors.status ? (
          <>
            <div className="text-danger">{errors.status}</div>
          </>
        ) : newStatus ? (
          <SelectForm
            dropdownMatchSelectWidth={false}
            options={statuses}
            value={status}
            placeholder="Status"
            onChange={(e) => setStatus(e)}
            error={errors.status}
          />
        ) : (
          <h5 className="font-semi-bold text-sm text-black mb-0 mt-2">
            Status
          </h5>
        )}
        <div className={newStatus ? "py-2" : ""}>
          <div style={{ position: "relative" }}>
            <Button1
              style={{
                position: "absolute",
                top: "-16px",
                left: "50%",
                transform: "translate(-50%, 0px)",
              }}
              text={newStatus ? "Cancel" : "Add a new status"}
              option={newStatus ? "minus" : "plus"}
              onClick={() => setNewStatus(!newStatus)}
            />
            <hr />
          </div>
        </div>
      </div>
      <h5 className="font-semi-bold text-sm text-black">Comments</h5>
      <SelectForm
        onlyPlaceholder="Comment type"
        options={comment_type_options.filter(
          (d) => d.value !== "comment_service"
        )}
        value={commentType}
        onChange={(val) => {
          setCommentType(val);
          set_comment_state_id(undefined);
          setBody("");
          setCommentDate("");
          setErrors((prev) => ({ ...prev, commentDate: undefined }));
        }}
      />

      <div className="my-2">
        <SelectForm
          onlyPlaceholder="Comment state"
          options={comments_state.filter((d) => d.comment_type == commentType)}
          value={comment_state_id}
          onChange={(e) => {
            set_comment_state_id(e);
            setCommentDate("");
            setErrors((prev) => ({ ...prev, commentDate: undefined }));
          }}
        />
      </div>

      {requiresReminderDate && (
        <div className="mb-2">
          <DatePicker
            placeholder="Reminder date and time"
            style={{ width: "100%" }}
            showTime={{
              defaultValue: moment(NOTE_REMINDER_DEFAULT_TIME, "HH:mm"),
            }}
            format="YYYY-MM-DD HH:mm"
            disabledDate={(d) => !d || d.isBefore(moment(), "minute")}
            onChange={(_, dateString) => {
              setCommentDate(dateString ? `${dateString}:00` : "");
              setErrors((prev) => ({ ...prev, commentDate: undefined }));
            }}
          />
          {errors.commentDate && (
            <div className="text-danger text-sm mt-1">{errors.commentDate}</div>
          )}
        </div>
      )}

      <TextArea
        className="mb-2"
        placeholder="Comment"
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />

      <div className="d-flex justify-content-end">
        <BlueButton loading={loadingAsync} onClick={() => onSubmit()}>
          Add
        </BlueButton>
      </div>
    </div>
  );
};

const Supply = ({ order_rows_accepted, setType, unCheck }) => {
  const dispatch = useDispatch();
  const [supplySupplierData, setSupplySupplierData] = useState([]);
  const [data, setData] = useState([]);
  const [orderRows, setOrderRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (order_rows_accepted.length == 0) return;

    getSuppliersOption().then((response) => {
      if (response.data) {
        let newArray = [];
        response.data.data.forEach((item) => {
          const findIndex = newArray.findIndex(
            (find) => find.name == item.name
          );
          if (findIndex == -1) {
            return newArray.push({
              value: item.id,
              name: item.name,
              code: item.code,
              label: item.title || item.name,
              is_code: item.is_code,
            });
          }
        });
        setSupplySupplierData(newArray);
      }
    });

    Axios.post("/api/v1/orders/post_search", {
      page: 1,
      per_page: 100000,
      q: {
        order_rows_id_in: order_rows_accepted,
      },
    }).then((res) => {
      setData(res.data.data || []);
      let or = [];
      res.data.data.forEach((d) => {
        d.order_rows.forEach((d) => {
          const findIndex = or.findIndex(
            (e) => e.product_reference == d.product_reference
          );
          if (findIndex !== -1) {
            if (or[findIndex].childrens) {
              or[findIndex].childrens = [...or[findIndex].childrens, d.id];
            } else {
              or[findIndex].childrens = [d.id];
            }
            return or;
          }
          return or.push(d);
        });
      });
      setOrderRows(or || []);
      setLoading(false);
    });
  }, []);

  if (order_rows_accepted.length == 0) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: 471,
        }}
      >
        Not selected
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: 471,
        }}
      >
        <Spin />
      </div>
    );
  }

  const onSubmit = async (supplyings, _, main_item) => {
    try {
      console.log(main_item);
      const params = {
        supplyings,
        main_item,
        order_rows: order_rows_accepted,
      };
      const { success } = await dispatch(
        postMassSupplyings(params, {
          orders_ids: data.map((d) => d.id),
        })
      );
      if (!success) throw new Error("ERR");
      setType("");
      const product = orderRows.find((d) => d.id == main_item);
      const build_array = [product.id, ...product.childrens];

      unCheck(
        "order_rows",
        order_rows_accepted.filter((id) => !build_array.includes(id))
      );
      return { success: true };
    } catch (err) {
      console.log("ERROR: ", err);
      return { success: false };
    }
  };

  return (
    <div>
      <h5 className="font-semi-bold text-sm text-black">Orders selected</h5>
      <div className="d-flex flex-wrap">
        {data.map((d) => (
          <div
            key={d.id_order}
            className="text-sm text-black mr-2 py-1 px-2 rounded bg-silver"
          >
            {d.id_order}
          </div>
        ))}
      </div>
      <SupplyComponent
        type="OrderBulkAction"
        order_rows={orderRows}
        supplySupplier={supplySupplierData}
        orderId={"order_id"}
        postOrderRow={onSubmit}
      />
    </div>
  );
};
